module.exports = __webpack_public_path__ + "img/sponsor-ank@2x.c11c0941.png";